import { forwardPage, forwardPageSync } from './forwardPage'
import { ICallback } from './interface'

/**
 * 唤起原生壳子注册 <br>
 * 在调起壳子的注册之后，会关闭当前的webview，但壳子不会回调调用传入的函数<br>
 * 因此，目前只能使用 viewAppear() 或直接使用 LightJSBridge.onPageAppear = () => {}
 *
 * @param {ICallback} { success, fail, complete }
 */
function evokeRegisterSync({ success, fail, complete }: ICallback) {
  const pageId = '1-3'
  const param = ''

  forwardPageSync({ pageId, param, success, fail, complete })
}

/**
 * 唤起原生壳子注册 <br>
 * 一个异步接口，支持 Promise 化使用
 * @returns
 */
function evokeRegister() {
  const pageId = '1-3'
  const param = ''

  return forwardPage({ pageId, param })
}

export { evokeRegister, evokeRegisterSync }
